import { useQuery } from "@tanstack/react-query";

import { getStatsToday, type StatsTodayOut } from "@/lib/api/stats";

export const STATS_TODAY_QUERY_KEY = ["stats", "today"] as const;

/** HomePage 의 오늘 통계 카드용 — 60초 주기로 자동 새로고침. */
export function useStatsToday() {
  return useQuery<StatsTodayOut>({
    queryKey: STATS_TODAY_QUERY_KEY,
    queryFn: getStatsToday,
    refetchInterval: 60_000,
    staleTime: 30_000,
  });
}
